import { ActionType, createAction, createAsyncAction } from "typesafe-actions";

import { TripType } from "@mapmycustomers/shared";
import { Activity, Trip } from "@mapmycustomers/shared/types/entity";

import IStop from "../types/IStop";

export const fetchActivities = createAction("@component/tripModal/fetchActivities")<{
  date: Date;
  failure?: () => void;
  success?: (activities: Activity[]) => void;
}>();

export const createTrips = createAsyncAction(
  "@component/tripModal/createTrips/request",
  "@component/tripModal/createTrips/success",
  "@component/tripModal/createTrips/failure"
)<{ onSuccess?: (trips: Trip[]) => void; stops: IStop[]; type: TripType }, Trip[], void>();

export const updateTrip = createAsyncAction(
  "@component/tripModal/updateTrip/request",
  "@component/tripModal/updateTrip/success",
  "@component/tripModal/updateTrip/failure"
)<
  {
    baseDate: Date;
    onFailure?: () => void;
    onSuccess?: (trip: Trip) => void;
    originalTrip: Trip;
    stops: IStop[];
  },
  Trip,
  unknown
>();

export type Actions = ActionType<typeof createTrips | typeof fetchActivities | typeof updateTrip>;
